document.addEventListener("DOMContentLoaded", () => {

// High demand box close
const closeBtn = document.getElementById('high-demand-box_close');
if (closeBtn) {
  closeBtn.addEventListener('click', function () {
    document.getElementById('high-demand-box').remove();
  });
}


  // Select the link (you might need a more specific selector if you have many links)
  const readMoreLink = document.querySelector('a[href="#tuotetiedot"]');

  if (readMoreLink) {
      readMoreLink.addEventListener('click', function(e) {
          // Prevent the default anchor link behavior (jumping to the ID)
          e.preventDefault();

          // Find the target element with the ID 'tuotetiedot'
          const targetElement = document.getElementById('tuotetiedot');

          if (targetElement) {
              // Programmatically trigger a click event on the target element
              targetElement.click();
          }
      });
  }

/* CHECK IF PRODUCT IS IN STOCK IN CURRENT SHOP */

/*
let debounceTimer;

const updateBehavior = (outcome) => {
    const submitBtn = document.querySelector('.product-form__submit');
    const drawerTrigger = document.querySelector('#ShowPickupAvailabilityDrawer');

    if (!submitBtn) return;

    if (outcome === 'NO') {
        // Intercept and redirect
        submitBtn.onclick = (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            if (drawerTrigger) drawerTrigger.click();
        };
    } else {
        // Restore normal behavior for YES
        submitBtn.onclick = null; 
        
    }
};

const observer = new MutationObserver(() => {
    clearTimeout(debounceTimer);
    
    debounceTimer = setTimeout(() => {
        const target = document.querySelector('pickup-availability .pickup-availability-info__location');
        document.querySelector('.product-form__buttons')?.classList.remove('hidden');
        
        if (target) {
            const rawClassString = target.getAttribute('class') || "";
            const classArray = rawClassString.split(/\s+/).filter(Boolean);
            const locationClasses = classArray.filter(c => c.toLowerCase().includes('location-'));

            if (locationClasses.length === 0) return;

            // Define the keywords to check for
            const keywords = ['lundberg', 'trek', 'scott'];
            
            // Check if any location class contains any of the keywords
            const hasMatch = locationClasses.some(className => 
                keywords.some(word => className.toLowerCase().includes(word))
            );

            if (hasMatch) {
                updateBehavior('YES');
            } else {
                updateBehavior('NO');
            }
        }
    }, 300); 
});

observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
});

*/



/* CHECK FOR TREK AND SCOTT ONLY PRODUCTS */
(function() {
  const updateAllDeliveryTexts = () => {
    // 1. Find the trigger element and target elements
    const pickupTarget = document.querySelector('pickup-availability-preview');
    const deliveryItems = document.querySelectorAll('.delivery-time');
    const inventoryMessages = document.querySelectorAll('.inventory-message');
    
    if (!pickupTarget) return;

    // 2. Determine states based on 'hidden' attribute or class
    const isHidden = pickupTarget.hasAttribute('hidden') || pickupTarget.classList.contains('external');
    
    const deliveryText = isHidden ? "Toimitusaika 2-3 viikkoa." : "Toimitusaika 2-3 arkipäivässä.";
    const inventoryText = isHidden ? "Tilaustuote." : "Varastossa.";

    // 3. Update all delivery-time elements
    deliveryItems.forEach((el) => {
      if (el.textContent !== deliveryText) {
        el.textContent = deliveryText;
      }
    });

    // 4. Update all inventory-message elements
    inventoryMessages.forEach((el) => {
      if (el.textContent !== inventoryText) {
        el.textContent = inventoryText;
      }
    });
  };

  // Observe the body for AJAX variant changes and attribute toggles
  const globalObserver = new MutationObserver(() => {
    updateAllDeliveryTexts();
  });

  globalObserver.observe(document.body, { 
    childList: true, 
    subtree: true, 
    attributes: true, 
    attributeFilter: ['class', 'hidden'] 
  });

  // Initial run
  updateAllDeliveryTexts();
})();


/* PRE-ORDER */
(function () {
  function getVariantData() {
    const el = document.getElementById('VariantMetafieldData');
    if (!el) {
      console.warn('[Velosport] VariantMetafieldData script tag not found.');
      return { productTitle: '', variants: [] };
    }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[Velosport] Failed to parse VariantMetafieldData JSON:', e);
      return { productTitle: '', variants: [] };
    }
  }

  const { productTitle, variants: variantData } = getVariantData();
  let lastVariantId = null;
  let originalHTML = null; // exact original innerHTML of location + pickup-time
  let overrideActive = false;

  function formatDate(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  function getElements() {
    const deliveryEl = document.querySelector('delivery-availability');
    if (!deliveryEl) return null;

    const previewEl = deliveryEl.querySelector('.pickup-availability-preview');
    const locationEl = deliveryEl.querySelector('.pickup-availability-info__location');
    const pickupTimeEl = deliveryEl.querySelector('.pickup-availability-info__pickup-time');

    // The price div is a direct child of the preview row with no class of its own —
    // select it by excluding the known icon/info siblings.
    const priceEl = previewEl
      ? previewEl.querySelector(':scope > div:not(.pickup-availability-icon):not(.pickup-availability-info)')
      : null;

    return { deliveryEl, locationEl, pickupTimeEl, priceEl };
  }

  function captureOriginalHTML(els) {
    if (originalHTML || !els.locationEl || !els.pickupTimeEl) return;
    originalHTML = {
      location: els.locationEl.innerHTML,
      pickupTime: els.pickupTimeEl.innerHTML,
    };
  }

  function getCurrentVariantId() {
    const hiddenInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return hiddenInput ? hiddenInput.value : null;
  }

  function applyState(variant) {
    const els = getElements();
    if (!els) return;

    captureOriginalHTML(els);

    const isOutOfStock = !variant.available;
    const hasPreOrderDate = !!variant.pre_order_date;

    if (!isOutOfStock) {
      // In stock: restore the exact original markup + price visible
      if (overrideActive) {
        els.deliveryEl.style.display = '';
        if (originalHTML) {
          els.locationEl.innerHTML = originalHTML.location;
          els.pickupTimeEl.innerHTML = originalHTML.pickupTime;
        }
        if (els.priceEl) els.priceEl.style.display = '';
        overrideActive = false;
        console.log(`[Velosport] Back in stock — restored original markup. Variant: "${variant.title}"`);
      }
      return;
    }

    if (!hasPreOrderDate) {
      els.deliveryEl.style.display = 'none';
      overrideActive = true;
      console.log(`[Velosport] Hiding <delivery-availability> — out of stock, no pre_order_date. Variant: "${variant.title}"`);
      return;
    }

    els.deliveryEl.style.display = '';
    els.pickupTimeEl.textContent = `Ennakkotilaa upouusi ${productTitle}! Tilaa ilmoitus, niin saat heti tiedon, kun tämä väri ja koko huippu-uutuudestamme saapuu verkkokauppaamme!`;
    els.locationEl.textContent = `Saatavilla uudelleen ${formatDate(variant.pre_order_date)}`;
    if (els.priceEl) els.priceEl.style.display = 'none';
    overrideActive = true;
    console.log(`[Velosport] Pre-order copy shown — Variant: "${variant.title}" | pre_order_date: ${variant.pre_order_date}`);
  }

  function checkVariant() {
    const variantId = getCurrentVariantId();
    if (!variantId || variantId === lastVariantId) return;

    lastVariantId = variantId;
    const variant = variantData.find((v) => String(v.id) === String(variantId));

    if (!variant) {
      console.log('[Velosport] Variant ID changed to', variantId, '— no matching data found.');
      return;
    }

    applyState(variant);
  }

  const observer = new MutationObserver(checkVariant);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['value', 'checked'],
  });

  document.addEventListener('change', checkVariant);
  checkVariant();
})();

  
/* MOVE MEGAMENU LINKS */

// Select all elements with the class 'mega-menu'
const megaMenus = document.querySelectorAll('.mega-menu');
const extraOffset = 15; // pixels to move further left

if (megaMenus.length > 0) {
  // 1. Get the position of the FIRST mega menu's parent relative to the viewport
  // This serves as the anchor point for all subsequent menus
  const firstParentRect = megaMenus[0].parentElement.getBoundingClientRect();
  const baseOffset = firstParentRect.left;

  // 2. Calculate the final shift based on the first parent + your extra offset
  const totalShiftLeft = baseOffset + extraOffset;

  megaMenus.forEach(menu => {
    menu.style.maxWidth = 'none';
    menu.style.width = '100vw';
    
    // 3. Apply the same uniform offset to every menu
    menu.style.left = `-${totalShiftLeft}px`;
  });
}


/* EXTERNAL LINKS */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

/* SLIDING LINKS */
$('a[href^="#"]').click(function(e) {
    var aid = $(this).attr("href");
    
    // Check if aid is not #recover and not #login
    if (aid !== "#recover" && aid !== "#login" && aid !== "#") {
        e.preventDefault();
        $('html,body').animate({scrollTop: $(aid).offset().top - 80},'slow');
    }
});

/* CLOSE AVAILABILITY DRAWER */
document.addEventListener('click', function(event) {
  // Check if click is on the submit button inside the pickup drawer
  const submitBtn = event.target.closest('pickup-availability-drawer .product-form__submit');
  
  if (submitBtn) {
    // Find the drawer's close button
    const closeBtn = document.querySelector('pickup-availability-drawer .drawer__close-btn');
    
    if (closeBtn) {
      // Trigger the close button click
      closeBtn.click();
    }
  }
});

/* CHECK FOR MOBILE */

$(document).ready(function() {
  /* MOBILE */
  $(function() {      
      let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
  
      if (isMobile) {
        console.log("MOBILE");
      }
   });
});

});